import Freight from './Freight'

export default Freight
